import printJS from 'print-js';
import { MoneyFormatv3 } from '../library/MoneyFormat';
import moment from 'moment';

// Helper function to format amount with ₹ symbol and red color for negative values
function formatAmountWithColor(amount, showCurrency = true) {
  const formattedAmount = MoneyFormatv3(amount) || '0.00';
  const isNegative = amount < 0;
  const color = isNegative ? '#FF0000' : 'inherit';
  const currencySymbol = showCurrency ? '₹ ' : '';
  return `<span style="color: ${color};">${currencySymbol}${formattedAmount}</span>`;
}

async function getTotal(rows) {
  const processNode = (node) => {
    let nodeTotal = 0;
    let nodeCredit = 0;
    let nodeDebit = 0;

    if (node.category === 'ledger') {
      const isDebit = node?.balancesign === -1;
      const debitAmount = isDebit ? node?.balance : 0;
      const creditAmount = !isDebit ? node?.balance : 0;
      nodeTotal = node?.balance || 0;
      nodeCredit = creditAmount || 0;
      nodeDebit = debitAmount || 0;
    } else if (node.children && node.children.length > 0) {
      // Recursively process children for groups
      node.children.forEach((child) => {
        const childTotals = processNode(child);
        nodeTotal += childTotals.total;
        nodeCredit += childTotals.credit;
        nodeDebit += childTotals.debit;
      });
    }

    return { total: nodeTotal, credit: nodeCredit, debit: nodeDebit };
  };

  return rows.reduce(
    (acc, data) => {
      const nodeTotals = processNode(data);
      acc.total += nodeTotals.total;
      acc.credit += nodeTotals.credit;
      acc.debit += nodeTotals.debit;
      return acc;
    },
    { total: 0, credit: 0, debit: 0 }
  );
}

export async function generateDashboardPrintableTable(
  params,
  tableHeaders,
  tableTitle,
  type = 'single',
  companyName,
  companyDetails,
  period,
  toogleAction
) {
  let { hideGroupTotal, hideZeroBalLedger } = toogleAction;

  console.log(params, 'params');

  const recursiveRowFn = (rows) => {
    return rows
      .map((row) => {
        if (row.children && row.children.length > 0) {
          // Sort children: ledgers first, then groups
          const sortedChildren = [...row.children].sort((a, b) => {
            const aIsLedger = a.category === 'ledger';
            const bIsLedger = b.category === 'ledger';
            const aIsGroup = a.category === 'group' || a.category === 'Category';
            const bIsGroup = b.category === 'group' || b.category === 'Category';

            // Ledgers come first
            if (aIsLedger && !bIsLedger) return -1;
            if (!aIsLedger && bIsLedger) return 1;

            // If both are same type, maintain original order
            return 0;
          });

          return [row, ...recursiveRowFn(sortedChildren)];
        }
        return row;
      })
      .flat();
  };

  const generateTableRows = (rows, headers, level) => {
    return rows
      .map((row) => {
        if (!(hideZeroBalLedger && row?.balance === 0 && row?.category === 'ledger')) {
          const isGroupRow = row.category === 'group' || row?.category === 'Category';

          const fontWeight = isGroupRow ? 'bold' : 'normal';
          const isDebit = row?.balancesign === -1;

          const debitAmount = isDebit ? row?.balance : 0;
          const creditAmount = !isDebit ? row?.balance : 0;

          return `
          <tr class="${isGroupRow ? ' group-row' : ''}">
           ${headers
              .map((header) => {
                if (header.key === 'amount') {
                  if (type === 'TrialBalance') {
                    return `
                <td style="border: 1px solid #000; padding: 8px; text-align: ${header.align || ' left'}; font-weight:${fontWeight};">
                 ${!isGroupRow ? `${formatAmountWithColor(debitAmount || 0)}` : ''}
                </td>
                <td style="border: 1px solid #000; padding: 8px; text-align: ${header.align || ' left'}; font-weight:${fontWeight};">
                  ${isGroupRow && !hideGroupTotal ? `${formatAmountWithColor(debitAmount || 0)}` : ''}
                </td>
                   <td style="border: 1px solid #000; padding: 8px; text-align: ${header.align || ' left'}; font-weight:${fontWeight};">
                 ${!isGroupRow ? `${formatAmountWithColor(creditAmount || 0)}` : ''}
                </td>
                <td style="border: 1px solid #000; padding: 8px; text-align: ${header.align || ' left'}; font-weight:${fontWeight};">
                  ${isGroupRow && !hideGroupTotal ? `${formatAmountWithColor(creditAmount || 0)}` : ''}
                </td>
                   `;
                  } else if (type === 'Item') {
                    return `
                <td style="border: 1px solid #000; padding: 8px; text-align: ${header.align || ' left'}; font-weight:${fontWeight};">
                 ${!isGroupRow ? `${row?.qty || 0}` : ''}
                </td>
                <td style="border: 1px solid #000; padding: 8px; text-align: ${header.align || ' left'}; font-weight:${fontWeight};">
                  ${isGroupRow && !hideGroupTotal ? `${row?.qty || 0}` : ''}
                </td>
                   <td style="border: 1px solid #000; padding: 8px; text-align: ${header.align || ' left'}; font-weight:${fontWeight};">
                 ${!isGroupRow ? `${formatAmountWithColor(row?.price || 0)}` : ''}
                </td>
                <td style="border: 1px solid #000; padding: 8px; text-align: ${header.align || ' left'}; font-weight:${fontWeight};">
                  ${isGroupRow && !hideGroupTotal ? `${formatAmountWithColor(row?.price || 0)}` : ''}
                </td>
                   `;
                  } else {
                    return `
                <td style=" border: 1px solid #000; padding: 8px; text-align: ${header.align || ' left'};font-weight:${fontWeight}; ">
                 ${!isGroupRow && type !== 'Item' ? `${formatAmountWithColor(row?.balance || 0)}` : ''}
                </td>
                <td style=" border: 1px solid #000; padding: 8px; text-align: ${header.align || ' left'}; font-weight:${fontWeight};">
                  ${isGroupRow && !hideGroupTotal && type !== 'Item' ? `${formatAmountWithColor(row?.balance || 0)}` : ''}
                </td>
                  `;
                  }
                }
                if (type === 'Item' && (header.key === 'qty' || header.key === 'price')) {
                  if (header.key === 'qty') {
                    return `
                <td style="border: 1px solid #000; padding: 8px; text-align: ${header.align || ' left'}; font-weight:${fontWeight};">
                 ${!isGroupRow ? `${row?.qty || 0}` : ''}
                </td>
                <td style="border: 1px solid #000; padding: 8px; text-align: ${header.align || ' left'}; font-weight:${fontWeight};">
                  ${isGroupRow && !hideGroupTotal ? `${row?.qty || 0}` : ''}
                </td>
                   `;
                  } else if (header.key === 'price') {
                    return `
                <td style="border: 1px solid #000; padding: 8px; text-align: ${header.align || ' left'}; font-weight:${fontWeight};">
                 ${!isGroupRow ? `${formatAmountWithColor(row?.price || 0)}` : ''}
                </td>
                <td style="border: 1px solid #000; padding: 8px; text-align: ${header.align || ' left'}; font-weight:${fontWeight};">
                  ${isGroupRow && !hideGroupTotal ? `${formatAmountWithColor(row?.price || 0)}` : ''}
                </td>
                   `;
                  }
                }
                return `
                   <td style="border: 1px solid #000;  padding: 8px; text-align: ${header.align || 'left'}; font-weight:${fontWeight};">
                   ${'&nbsp;'.repeat(row.level * 4) + row[header.key]}
                   </td>`;
              })
              .join('')}
        </tr>`;
        }
      })
      .join('');
  };

  let printableTable = `
<style>
  @media print {
    .group-row {
      background-color: #d3d3d3 !important;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
    .openingDiff td {
    color: red !important;
    }

    .totalRow {
      background-color: rgb(152, 152, 152) !important;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }

    th {
      background-color: #f4f4f4 !important;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
  }
</style>
<div>
  <h2 style="text-align: center; margin-bottom: 5px;">${companyName}</h2>
  ${companyDetails
      ? `
    <div style="text-align: center; margin-bottom: 10px;">
      ${companyDetails.line1 ? `<div style="font-size: 12px; margin-bottom: 2px;">${companyDetails.line1}</div>` : ''}
      ${companyDetails.line2 ? `<div style="font-size: 12px; margin-bottom: 2px;">${companyDetails.line2}</div>` : ''}
      ${(() => {
        // Check if location details are already included in line1
        const line1Text = companyDetails.line1 ? companyDetails.line1.toLowerCase() : '';
        const city = companyDetails.city ? companyDetails.city.toLowerCase() : '';
        const district = companyDetails.district ? companyDetails.district.toLowerCase() : '';
        const state = companyDetails.statename ? companyDetails.statename.toLowerCase() : '';
        const pincode = companyDetails.pincode ? companyDetails.pincode : '';

        // Check if any of the location details are already in line1
        const cityInLine1 = city && line1Text.includes(city);
        const districtInLine1 = district && line1Text.includes(district);
        const stateInLine1 = state && line1Text.includes(state);
        const pincodeInLine1 = pincode && line1Text.includes(pincode);

        // Only show separate location if not already included in line1
        const shouldShowLocation =
          (companyDetails.city || companyDetails.district || companyDetails.statename || companyDetails.pincode) &&
          !(cityInLine1 && districtInLine1 && stateInLine1 && pincodeInLine1);

        if (shouldShowLocation) {
          return `<div style="font-size: 12px; margin-bottom: 2px;">
            ${companyDetails.city ? companyDetails.city : ''}${companyDetails.city && companyDetails.district ? ', ' : ''}${companyDetails.district ? companyDetails.district : ''
            }${(companyDetails.city || companyDetails.district) && companyDetails.statename ? ', ' : ''}${companyDetails.statename ? companyDetails.statename : ''
            }${(companyDetails.city || companyDetails.district || companyDetails.statename) && companyDetails.pincode ? ' - ' : ''}${companyDetails.pincode ? companyDetails.pincode : ''
            }
          </div>`;
        }
        return '';
      })()}
    </div>
  `
      : ''
    }
  <div style="text-align: center; margin-bottom: 10px;">
    <h3 style="margin: 0; font-size: 14px; display: inline;">${tableTitle}</h3>
    <span style="margin: 0 1px; font-size: 14px;">:</span>
    <p style="margin: 0; font-size: 14px; display: inline;">${(() => {
      const normalizedType = String(type || '').toLowerCase();
      const isAsOnType = ['balancesheet', 'trialbalance', 'receivables', 'receivable', 'payables', 'payable'].includes(normalizedType);

      const start = period?.startdate ? moment(period.startdate * 1000) : null;
      const end = period?.enddate ? moment(period.enddate * 1000) : null;

      const startText = start ? start.format('DD-MMM-YYYY') : '';
      const endText = end ? end.format('DD-MMM-YYYY') : '';

      const isSingleDay = Boolean(start && end && start.isSame(end, 'day'));

      const rangeText = !startText
        ? endText
        : !endText
          ? startText
          : isSingleDay
            ? startText
            : startText + ' to ' + endText;

      if (isAsOnType) {
        const asOnText = endText || startText || '';
        return `As on: ${asOnText}`;
      }

      return `Period: ${rangeText}`;
    })()}</p>
  </div>
</div>

`;

  if (type === 'pandl') {
    const flatExpenseFirstRows = recursiveRowFn(params.expenseFirstPart || []);
    const flatIncomeFirstRows = recursiveRowFn(params.incomeFirstPart || []);
    const flatExpenseSecondRows = recursiveRowFn(params.expenseSecondPart || []);
    const flatIncomeSecondRows = recursiveRowFn(params.incomeSecondPart || []);

    // Calculate first part group totals - only Trading Expense + Direct Expense for expense side
    // and Trading Incomes + Direct Income for income side
    const calculateFirstPartGroupTotal = (rows, isExpense) => {
      const targetGroups = isExpense
        ? ['Trading Expense', 'Direct Expense']
        : ['Trading Incomes', 'Direct Income'];

      return rows.reduce((sum, row) => {
        if ((row.category === 'group' || row.category === 'Category') &&
          targetGroups.includes(row.name)) {
          return sum + (row.balance || 0);
        }
        return sum;
      }, 0);
    };

    // Calculate second part group totals - only specific groups for expense and income sides
    const calculateSecondPartGroupTotal = (rows, isExpense) => {
      const targetGroups = isExpense
        ? ['Indirect Expenses', 'Depreciation & Amortisation', 'Interest Expenses', 'Tax Expenses']
        : ['Indirect Income'];

      return rows.reduce((sum, row) => {
        if ((row.category === 'group' || row.category === 'Category') &&
          targetGroups.includes(row.name)) {
          return sum + (row.balance || 0);
        }
        return sum;
      }, 0);
    };

    const isGrossProfit = params?.grossprotitOrLoss === 'profit';
    const isGrossLoss = params?.grossprotitOrLoss === 'loss';
    const isNetProfit = params?.protitOrLoss === 'profit';
    const isNetLoss = params?.protitOrLoss === 'loss';


    const expenseFirstGroupTotal = calculateFirstPartGroupTotal(params.expenseFirstPart || [], true) + (params?.openingStock?.balance || 0) + (isGrossProfit ? (params?.grossExpenseProfit || 0) : 0);
    const incomeFirstGroupTotal = calculateFirstPartGroupTotal(params.incomeFirstPart || [], false) + (params?.closingStockValue || 0) + (isGrossLoss ? (params?.grossIncomeloss || 0) : 0);
    const expenseSecondGroupTotal = calculateSecondPartGroupTotal(params.expenseSecondPart || [], true) + (isGrossLoss ? (Math.abs(params?.grossbdIncomeloss || 0)) : 0) + (isNetProfit ? (params?.netExpenseProfit || params?.netIncomeloss || 0) : 0);
    const incomeSecondGroupTotal = calculateSecondPartGroupTotal(params.incomeSecondPart || [], false) + (isGrossProfit ? (Math.abs(params?.grossbdExpenseProfit || 0)) : 0) + (isNetLoss ? (params?.netIncomeloss || 0) : 0);
    const generateExpenseFirstPartRows = () => {
      let rows = '';

      rows += `
      <tr>
        <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: normal; font-style: italic; line-height: 1.0;">
          Opening Stock
        </td>
        <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; line-height: 1.0;">
          ${formatAmountWithColor(params?.openingStock?.balance || 0)}
        </td>
        ${!hideGroupTotal
          ? `<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">${formatAmountWithColor(params?.openingStock?.balance || 0)}</td>`
          : ''
        }
      </tr>
    `;
      flatExpenseFirstRows.forEach((row) => {
        if (!(hideZeroBalLedger && row?.balance === 0 && row?.category === 'ledger')) {
          const isGroupRow = row.category === 'group' || row?.category === 'Category';
          const isSpecialGroup = row.id === 26 || row.id === 27 || row.id === 28; // EBITDA, EBIT, PBT
          const fontWeight = isGroupRow || isSpecialGroup ? 'bold' : 'normal';
          const fontStyle = isGroupRow || isSpecialGroup ? 'normal' : 'italic';
          const textColor = isGroupRow || isSpecialGroup ? '#911B7C' : 'inherit';

          rows += `
          <tr>
            <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: ${isGroupRow || isSpecialGroup ? '9pt' : '8pt'
            }; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0; ${isGroupRow || isSpecialGroup ? 'margin-bottom: 2px;' : ''
            }">
              ${'&nbsp;'.repeat((row.level || 0) * 8) + row.name}
            </td>
            <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow || isSpecialGroup ? '9pt' : '8pt'
            }; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0;">
              ${!(isGroupRow || isSpecialGroup) ? formatAmountWithColor(row?.balance || 0) : ''}
            </td>
            ${!hideGroupTotal
              ? `<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow || isSpecialGroup ? '9pt' : '8pt'
              }; font-weight: ${fontWeight}; font-style: italic; line-height: 1.0;">
              ${isGroupRow || isSpecialGroup ? formatAmountWithColor(row?.balance || 0) : ''}
            </td>`
              : ''
            }
          </tr>
        `;
        }
      });
      // Gross Profit c/f
      if (isGrossProfit) {
        rows += `
       <tr>
        <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; color: #008000; line-height: 1.0;">
          Gross Profit c/f
        </td>
        <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; color: #008000; line-height: 1.0;">
          ${formatAmountWithColor(params?.grossExpenseProfit || 0)}
        </td>
        ${!hideGroupTotal
            ? `<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; color: #008000; line-height: 1.0;">${formatAmountWithColor(params?.grossExpenseProfit || 0)}</td>`
            : ''
          }
      </tr>
      `;
      }
      return rows;
    };

    const generateExpenseSecondPartRows = () => {
      let rows = '';

      if (isGrossLoss) {
        rows += `
       <tr>
        <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; color: #FF0000; line-height: 1.0;">
          Gross Loss b/d
        </td>
        <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; color: #FF0000; line-height: 1.0;">
          ${formatAmountWithColor((params?.grossbdIncomeloss || 0) * -1)}
        </td>
        ${!hideGroupTotal
            ? `<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; color: #FF0000; line-height: 1.0;">${formatAmountWithColor((params?.grossbdIncomeloss || 0) * -1)}</td>`
            : ''
          }
      </tr>
      `;
      }
      flatExpenseSecondRows.forEach((row) => {
        if (!(hideZeroBalLedger && row?.balance === 0 && row?.category === 'ledger')) {
          const isGroupRow = row.category === 'group' || row?.category === 'profitability';
          const fontWeight = isGroupRow ? 'bold' : 'normal';
          const fontStyle = isGroupRow ? 'normal' : 'italic';
          const textColor = isGroupRow ? '#911B7C' : 'inherit';

          rows += `
          <tr>
            <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'
            }; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0; ${isGroupRow ? 'margin-bottom: 2px;' : ''
            }">
              ${'&nbsp;'.repeat((row.level || 0) * 8) + row.name}
            </td>
            <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'
            }; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0;">
              ${!isGroupRow ? formatAmountWithColor(row?.balance || 0) : ''}
            </td>
            ${!hideGroupTotal
              ? `<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'
              }; font-weight: ${fontWeight}; font-style: italic; line-height: 1.0;">
              ${isGroupRow ? formatAmountWithColor(row?.balance || 0) : ''}
            </td>`
              : ''
            }
          </tr>
        `;
        }
      });

      return rows;
    };

    const generateIncomeFirstPartRows = () => {
      let rows = '';

      rows += `
      <tr>
        <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: normal; font-style: italic; line-height: 1.0;">
          Closing Stock
        </td>
        <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; line-height: 1.0;">
          ${formatAmountWithColor(params?.closingStockValue || 0)}
        </td>
        ${!hideGroupTotal
          ? `<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">${formatAmountWithColor(params?.closingStockValue || 0)}</td>`
          : ''
        }
      </tr>
    `;
      flatIncomeFirstRows.forEach((row) => {
        if (!(hideZeroBalLedger && row?.balance === 0 && row?.category === 'ledger')) {
          const isGroupRow = row.category === 'group' || row?.category === 'Category';
          const isSpecialGroup = row.id === 26 || row.id === 27 || row.id === 28; // EBITDA, EBIT, PBT
          const fontWeight = isGroupRow || isSpecialGroup ? 'bold' : 'normal';
          const fontStyle = isGroupRow || isSpecialGroup ? 'normal' : 'italic';
          const textColor = isGroupRow || isSpecialGroup ? '#911B7C' : 'inherit';

          rows += `
          <tr>
            <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: ${isGroupRow || isSpecialGroup ? '9pt' : '8pt'
            }; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0; ${isGroupRow || isSpecialGroup ? 'margin-bottom: 2px;' : ''
            }">
              ${'&nbsp;'.repeat((row.level || 0) * 8) + row.name}
            </td>
            <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow || isSpecialGroup ? '9pt' : '8pt'
            }; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0;">
              ${!(isGroupRow || isSpecialGroup) ? formatAmountWithColor(row?.balance || 0) : ''}
            </td>
            ${!hideGroupTotal
              ? `<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow || isSpecialGroup ? '9pt' : '8pt'
              }; font-weight: ${fontWeight}; font-style: italic; line-height: 1.0;">
              ${isGroupRow || isSpecialGroup ? formatAmountWithColor(row?.balance || 0) : ''}
            </td>`
              : ''
            }
          </tr>
        `;
        }
      });

      if (isGrossLoss) {
        rows += `
       <tr>
        <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; color: #FF0000; line-height: 1.0;">
          Gross Loss c/f
        </td>
        <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; color: #FF0000; line-height: 1.0;">
          ${formatAmountWithColor(params?.grossIncomeloss || 0)}
        </td>
        ${!hideGroupTotal
            ? `<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; color: #FF0000; line-height: 1.0;">${formatAmountWithColor(params?.grossIncomeloss || 0)}</td>`
            : ''
          }
      </tr>
      `;
      }

      return rows;
    };

    const generateIncomeSecondPartRows = () => {
      let rows = '';

      if (isGrossProfit) {
        rows += `
       <tr>
        <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; color: #008000; line-height: 1.0;">
          Gross Profit b/d
        </td>
        <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; color: #008000; line-height: 1.0;">
          ${formatAmountWithColor(Math.abs(params?.grossbdExpenseProfit || 0))}
        </td>
        ${!hideGroupTotal
            ? `<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; color: #008000; line-height: 1.0;">${formatAmountWithColor(Math.abs(params?.grossbdExpenseProfit || 0))}</td>`
            : ''
          }
      </tr>
      `;
      }
      flatIncomeSecondRows.forEach((row) => {
        if (!(hideZeroBalLedger && row?.balance === 0 && row?.category === 'ledger')) {
          const isGroupRow = row.category === 'group' || row?.category === 'Category';
          const isSpecialGroup = row.id === 26 || row.id === 27 || row.id === 28; // EBITDA, EBIT, PBT
          const fontWeight = isGroupRow || isSpecialGroup ? 'bold' : 'normal';
          const fontStyle = isGroupRow || isSpecialGroup ? 'normal' : 'italic';
          const textColor = isGroupRow || isSpecialGroup ? '#911B7C' : 'inherit';

          rows += `
          <tr>
            <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: ${isGroupRow || isSpecialGroup ? '9pt' : '8pt'
            }; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0; ${isGroupRow || isSpecialGroup ? 'margin-bottom: 2px;' : ''
            }">
              ${'&nbsp;'.repeat((row.level || 0) * 8) + row.name}
            </td>
            <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow || isSpecialGroup ? '9pt' : '8pt'
            }; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0;">
              ${!(isGroupRow || isSpecialGroup) ? formatAmountWithColor(row?.balance || 0) : ''}
            </td>
            ${!hideGroupTotal
              ? `<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow || isSpecialGroup ? '9pt' : '8pt'
              }; font-weight: ${fontWeight}; font-style: italic; line-height: 1.0;">
              ${isGroupRow || isSpecialGroup ? formatAmountWithColor(row?.balance || 0) : ''}
              </td>`
              : ''
            }
            </tr>
          `;
        }
      });

      return rows;
    };

    printableTable += `
<style>
  @media print {
  @page {
    size: A4 portrait;
    margin: 0.1in;
  }
    body {
      font-family: Calibri, Arial;
      font-size: 9pt;
      line-height: 1.1;
    }
  }
</style>
<div style="width: 100%; font-family: Calibri, Arial; margin: 0; padding: 0;">
  <table style="width: 100%; border-collapse: collapse; font-size: 9pt; line-height: 1.1;">
    <thead>
      <tr>
        <th style="width: ${hideGroupTotal ? '32.5%' : '22.5%'
      }; padding: 4px; text-align: left; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; background-color: #911B7C; color: white;">
          Expense
        </th>
        <th style="width: ${hideGroupTotal ? '17.5%' : '13.75%'
      }; padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''
      } background-color: #911B7C; color: white;">
          Amount
        </th>
        ${!hideGroupTotal
        ? `<th style="width: 13.75%; padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; background-color: #911B7C; color: white;">
          Group Total
        </th>`
        : ''
      }
        <th style="width: ${hideGroupTotal ? '32.5%' : '22.5%'
      }; padding: 4px; text-align: left; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; background-color: #C8087F; color: white;">
          Income
        </th>
        <th style="width: ${hideGroupTotal ? '17.5%' : '13.75%'
      }; padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''
      } background-color: #C8087F; color: white;">
          Amount
        </th>
        ${!hideGroupTotal
        ? `<th style="width: 13.75%; padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; background-color: #C8087F; color: white;">
          Group Total
        </th>`
        : ''
      }
      </tr>
    </thead>
    <tbody>
      <tr>
        <td colspan="${hideGroupTotal ? '2' : '3'}" style="width: 50%; padding: 0; vertical-align: top; border-left: 1px solid #000;">
          <table style="width: 100%; border-collapse: collapse;">
            <colgroup>
              <col style="width: ${hideGroupTotal ? '65%' : '45%'};">
              <col style="width: ${hideGroupTotal ? '35%' : '27.5%'};">
              ${!hideGroupTotal ? '<col style="width: 27.5%;">' : ''}
            </colgroup>
            <tbody>
              ${generateExpenseFirstPartRows()}
            </tbody>
          </table>
        </td>
        <td colspan="${hideGroupTotal ? '2' : '3'
      }" style="width: 50%; padding: 0; vertical-align: top; border-left: 1px solid #000; border-right: 1px solid #000;">
          <table style="width: 100%; border-collapse: collapse;">
            <colgroup>
              <col style="width: ${hideGroupTotal ? '65%' : '45%'};">
              <col style="width: ${hideGroupTotal ? '35%' : '27.5%'};">
              ${!hideGroupTotal ? '<col style="width: 27.5%;">' : ''}
            </colgroup>
            <tbody>
              ${generateIncomeFirstPartRows()}
            </tbody>
          </table>
        </td>
      </tr>

      <!-- First Total Row -->
      <tr>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">
           Total
        </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; line-height: 1.0; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''
      }">
          ${formatAmountWithColor(params?.firstTotal || 0)}
        </td>
        ${!hideGroupTotal
        ? `<td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; line-height: 1.0;">
          ${formatAmountWithColor(expenseFirstGroupTotal || 0)}
        </td>`
        : ''
      }
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">
           Total
        </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; line-height: 1.0; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''
      }">
          ${formatAmountWithColor(params?.firstTotal || 0)}
        </td>
        ${!hideGroupTotal
        ? `<td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; line-height: 1.0;">
          ${formatAmountWithColor(incomeFirstGroupTotal || 0)}
        </td>`
        : ''
      }
      </tr>
      
      <tr>
        <td colspan="${hideGroupTotal ? '2' : '3'}" style="width: 50%; padding: 0; vertical-align: top; border-left: 1px solid #000;">
          <table style="width: 100%; border-collapse: collapse;">
            <colgroup>
              <col style="width: ${hideGroupTotal ? '65%' : '45%'};">
              <col style="width: ${hideGroupTotal ? '35%' : '27.5%'};">
              ${!hideGroupTotal ? '<col style="width: 27.5%;">' : ''}
            </colgroup>
            <tbody>
              ${generateExpenseSecondPartRows()}
            </tbody>
          </table>
        </td>
        <td colspan="${hideGroupTotal ? '2' : '3'
      }" style="width: 50%; padding: 0; vertical-align: top; border-left: 1px solid #000; border-right: 1px solid #000;">
          <table style="width: 100%; border-collapse: collapse;">
            <colgroup>
              <col style="width: ${hideGroupTotal ? '65%' : '45%'};">
              <col style="width: ${hideGroupTotal ? '35%' : '27.5%'};">
              ${!hideGroupTotal ? '<col style="width: 27.5%;">' : ''}
            </colgroup>
            <tbody>
              ${generateIncomeSecondPartRows()}
            </tbody>
          </table>
        </td>
      </tr>

      <!-- Net Profit/Loss Row -->
      ${isNetProfit
        ? `
      <tr>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; color: #008000; line-height: 1.0;">
          Net Profit
        </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; color: #008000; line-height: 1.0; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''
        }">
          ${formatAmountWithColor(params?.netExpenseProfit || params?.netIncomeloss || 0)}
        </td>
        ${!hideGroupTotal
          ? `<td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; color: #008000; line-height: 1.0;">${formatAmountWithColor(params?.netExpenseProfit || params?.netIncomeloss || 0)}</td>`
          : ''
        }
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">
        </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''
        }">
        </td>
        ${!hideGroupTotal
          ? '<td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;"></td>'
          : ''
        }
      </tr>
      `
        : ''
      }
      ${isNetLoss
        ? `
      <tr>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">
        </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''
        }">
        </td>
        ${!hideGroupTotal
          ? '<td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;"></td>'
          : ''
        }
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; color: #FF0000; line-height: 1.0;">
          Net Loss
        </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; color: #FF0000; line-height: 1.0; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''
        }">
          ${formatAmountWithColor(params?.netIncomeloss || 0)}
        </td>
        ${!hideGroupTotal
          ? `<td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; color: #FF0000; line-height: 1.0;">${formatAmountWithColor(params?.netIncomeloss || 0)}</td>`
          : ''
        }
      </tr>
      `
        : ''
      }

      <!-- Final Total Row -->
      <tr>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">
          Total
        </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; line-height: 1.0; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''
      }">
          ${formatAmountWithColor(params?.pandLTotal || 0)}
        </td>
        ${!hideGroupTotal
        ? `<td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; line-height: 1.0;">
          ${formatAmountWithColor(expenseSecondGroupTotal || 0)}
        </td>`
        : ''
      }
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">
          Total
        </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; line-height: 1.0; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''
      }">
          ${formatAmountWithColor(params?.pandLTotal || 0)}
        </td>
        ${!hideGroupTotal
        ? `<td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; line-height: 1.0;">
          ${formatAmountWithColor(incomeSecondGroupTotal || 0)}
        </td>`
        : ''
      }
      </tr>
    </tbody>
  </table>
</div>
`;
  } else if (type === 'balancesheet') {
    const flatLiabilities = recursiveRowFn(params.liabilities || []);
    const flatAssets = recursiveRowFn(params.assets || []);

    let { total: totalLiabilities } = await getTotal(params.liabilities);
    let { total: totalAssets } = await getTotal(params.assets);

    const liabilitiesCondition =
      (params?.openingBalanceDiff?.credit !== 0 && params?.openingBalanceDiff?.balance > 0) ||
      (params?.openingBalanceDiff?.credit === 0 && params?.openingBalanceDiff?.balance < 0);
    const assetsCondition =
      (params?.openingBalanceDiff?.credit !== 0 && params?.openingBalanceDiff?.balance < 0) ||
      (params?.openingBalanceDiff?.credit === 0 && params?.openingBalanceDiff?.balance > 0);
    const totalLiabilitiesDiff = liabilitiesCondition ? params?.openingBalanceDiff?.balance : 0;
    const totalAssetsDiff = assetsCondition ? params?.openingBalanceDiff?.balance : 0;
    totalLiabilities = totalLiabilities + totalLiabilitiesDiff;
    totalAssets = totalAssets + totalAssetsDiff;

    const generateLiabilitiesRows = () => {
      let rows = '';

      flatLiabilities.forEach((row) => {
        if (!(hideZeroBalLedger && row?.balance === 0 && row?.category === 'ledger')) {
          const isGroupRow = row.category === 'group' || row?.category === 'Category';
          const fontWeight = isGroupRow ? 'bold' : 'normal';
          const fontStyle = isGroupRow ? 'normal' : 'italic';
          const textColor = isGroupRow ? '#911B7C' : 'inherit';

          rows += `
            <tr>
              <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'
            }; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0; ${isGroupRow ? 'margin-bottom: 2px;' : ''
            }">
                ${'&nbsp;'.repeat((row.level || 0) * 8) + row.name}
              </td>
              <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'
            }; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0;">
                ${!isGroupRow ? formatAmountWithColor(row?.balance || 0) : ''}
              </td>
              ${!hideGroupTotal
              ? `<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'
              }; font-weight: ${fontWeight}; font-style: italic; line-height: 1.0;">
                ${isGroupRow ? formatAmountWithColor(row?.balance || 0) : ''}
              </td>`
              : ''
            }
    </tr>
          `;
        }
      });

      if (liabilitiesCondition) {
        rows += `
          <tr>
            <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: normal; font-style: italic; color: #FF0000; line-height: 1.0;">
          ${params?.openingBalanceDiff?.name}
        </td>
            <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; color: #FF0000; line-height: 1.0;">
              ${formatAmountWithColor(params?.openingBalanceDiff?.balance || 0)}
        </td>
            ${!hideGroupTotal
            ? `<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; color: #FF0000; line-height: 1.0;">${formatAmountWithColor(params?.openingBalanceDiff?.balance || 0)}</td>`
            : ''
          }
          </tr>
        `;
      }

      return rows;
    };

    const generateAssetsRows = () => {
      let rows = '';

      flatAssets.forEach((row) => {
        if (!(hideZeroBalLedger && row?.balance === 0 && row?.category === 'ledger')) {
          const isGroupRow = row.category === 'group' || row?.category === 'Category';
          const fontWeight = isGroupRow ? 'bold' : 'normal';
          const fontStyle = isGroupRow ? 'normal' : 'italic';
          const textColor = isGroupRow ? '#911B7C' : 'inherit';

          rows += `
            <tr>
              <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'
            }; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0; ${isGroupRow ? 'margin-bottom: 2px;' : ''
            }">
                ${'&nbsp;'.repeat((row.level || 0) * 8) + row.name}
      </td>
              <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'
            }; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0;">
                ${!isGroupRow ? formatAmountWithColor(row?.balance || 0) : ''}
        </td>
              ${!hideGroupTotal
              ? `<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'
              }; font-weight: ${fontWeight}; font-style: italic; line-height: 1.0;">
                ${isGroupRow ? formatAmountWithColor(row?.balance || 0) : ''}
              </td>`
              : ''
            }
    </tr>
          `;
        }
      });

      if (assetsCondition) {
        rows += `
          <tr>
            <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: normal; font-style: italic; color: #FF0000; line-height: 1.0;">
              ${params?.openingBalanceDiff?.name}
            </td>
            <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; color: #FF0000; line-height: 1.0;">
              ${formatAmountWithColor(params?.openingBalanceDiff?.balance || 0)}
            </td>
            ${!hideGroupTotal
            ? `<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; color: #FF0000; line-height: 1.0;">${formatAmountWithColor(params?.openingBalanceDiff?.balance || 0)}</td>`
            : ''
          }
    </tr>
        `;
      }

      return rows;
    };

    printableTable += `
<div style="width: 100%; font-family: Calibri, Arial; margin: 0; padding: 0;">
  <table style="width: 100%; border-collapse: collapse; font-size: 9pt; line-height: 1.1;">
    <thead>
      <tr>
        <th style="width: ${hideGroupTotal ? '37.5%' : '25%'
      }; padding: 4px; text-align: left; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; background-color: #911B7C; color: white;">
          Liabilities
        </th>
        <th style="width: ${hideGroupTotal ? '12.5%' : '12.5%'
      }; padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''
      } background-color: #911B7C; color: white;">
          Amount
        </th>
        ${!hideGroupTotal
        ? `<th style="width: 12.5%; padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; background-color: #911B7C; color: white;">
          Group Total
        </th>`
        : ''
      }
        <th style="width: ${hideGroupTotal ? '37.5%' : '25%'
      }; padding: 4px; text-align: left; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; background-color: #C8087F; color: white;">
          Assets
        </th>
        <th style="width: ${hideGroupTotal ? '12.5%' : '12.5%'
      }; padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''
      } background-color: #C8087F; color: white;">
          Amount
        </th>
        ${!hideGroupTotal
        ? `<th style="width: 12.5%; padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; background-color: #C8087F; color: white;">
          Group Total
        </th>`
        : ''
      }
    </tr>
    </thead>
    <tbody>
      <tr>
        <td colspan="${hideGroupTotal ? '2' : '3'}" style="width: 50%; padding: 0; vertical-align: top; border-left: 1px solid #000;">
          <table style="width: 100%; border-collapse: collapse;">
            <colgroup>
              <col style="width: ${hideGroupTotal ? '75%' : '50%'};">
              <col style="width: ${hideGroupTotal ? '25%' : '25%'};">
              ${!hideGroupTotal ? '<col style="width: 25%;">' : ''}
            </colgroup>
            <tbody>
              ${generateLiabilitiesRows()}
            </tbody>
          </table>
        </td>
        <td colspan="${hideGroupTotal ? '2' : '3'
      }" style="width: 50%; padding: 0; vertical-align: top; border-left: 1px solid #000; border-right: 1px solid #000;">
          <table style="width: 100%; border-collapse: collapse;">
            <colgroup>
              <col style="width: ${hideGroupTotal ? '75%' : '50%'};">
              <col style="width: ${hideGroupTotal ? '25%' : '25%'};">
              ${!hideGroupTotal ? '<col style="width: 25%;">' : ''}
            </colgroup>
            <tbody>
              ${generateAssetsRows()}
            </tbody>
          </table>
        </td>
      </tr>

      <!-- Total Row -->
      <tr>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">
          Total
        </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; line-height: 1.0; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''
      }">
          ${formatAmountWithColor(totalLiabilities || 0)}
        </td>
        ${!hideGroupTotal
        ? `<td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; line-height: 1.0;">
          ${formatAmountWithColor(totalLiabilities || 0)}
        </td>`
        : ''
      }
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">
        Total
      </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; line-height: 1.0; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''
      }">
          ${formatAmountWithColor(totalAssets || 0)}
        </td>
        ${!hideGroupTotal
        ? `<td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; line-height: 1.0;">
          ${formatAmountWithColor(totalAssets || 0)}
        </td>`
        : ''
      }
      </tr>
    </tbody>
  </table>
  </div>
  `;
  } else if (type === 'TrialBalance') {
    const flatRows = recursiveRowFn(params.rows || []);
    const { credit, debit } = await getTotal(params.rows);
    const totalCredit = params?.openingBalanceDiff.credit + credit;
    const totalDebit = params?.openingBalanceDiff.debit + debit;

    printableTable += `
<div style="width: 100%; font-family: Calibri, Arial; margin: 0; padding: 0;">
  <table style="width: 100%; border-collapse: collapse; font-size: 9pt; line-height: 1.1;">
    <thead>
     <tr>
        <th ${hideGroupTotal ? '' : 'rowspan="2"'} style="width: ${hideGroupTotal ? '60%' : '40%'
      }; padding: 4px; text-align: left; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; background-color: #911B7C; color: white;">
          Particular
        </th>
        ${hideGroupTotal
        ? `
        <th style="width: 20%; padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; background-color: #911B7C; color: white;">
          Debit
        </th>
        <th style="width: 20%; padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; background-color: #911B7C; color: white;">
          Credit
        </th>
        `
        : `
        <th colspan="2" style="padding: 4px; text-align: center; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; background-color: #911B7C; color: white;">
          Debit
        </th>
        <th colspan="2" style="padding: 4px; text-align: center; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-right: 1px solid #000; background-color: #911B7C; color: white;">
          Credit
        </th>
        `
      }
    </tr>
    ${!hideGroupTotal
        ? `
    <tr>
        <th style="padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-bottom: 1px solid #000; background-color: #911B7C; color: white;">
          Amount
        </th>
        <th style="padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-bottom: 1px solid #000; background-color: #911B7C; color: white;">
          Group Total
        </th>
        <th style="padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-bottom: 1px solid #000; background-color: #911B7C; color: white;">
          Amount
        </th>
        <th style="padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-bottom: 1px solid #000; border-right: 1px solid #000; background-color: #911B7C; color: white;">
          Group Total
        </th>
    </tr>
    `
        : ''
      }
    </thead>
    <tbody>
      ${flatRows
        .map((row) => {
          if (hideZeroBalLedger && row?.balance === 0 && row?.category === 'ledger') {
            return '';
          }

          const isGroupRow = row.category === 'group' || row?.category === 'Category';
          const fontWeight = isGroupRow ? 'bold' : 'normal';
          const fontStyle = isGroupRow ? 'normal' : 'italic';
          const textColor = isGroupRow ? '#911B7C' : 'inherit';
          const isDebit = row?.balancesign === -1;
          const isCredit = row?.balancesign === 1;

          if (hideGroupTotal) {
            // When hideGroupTotal is true, show balance directly in Debit or Credit column
            // But hide group total amounts - only show amounts for ledger rows
            const debitValue = isGroupRow ? '' : isDebit ? formatAmountWithColor(row?.balance || 0) : '--';
            const creditValue = isGroupRow ? '' : isCredit ? formatAmountWithColor(row?.balance || 0) : '--';

            return `
          <tr>
            <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'
              }; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0; ${isGroupRow ? 'margin-bottom: 2px;' : ''
              } border-left: 1px solid #000;">
              ${'&nbsp;'.repeat((row.level || 0) * 8) + row.name}
            </td>
            <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'
              }; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0;">
              ${debitValue}
            </td>
            <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'
              }; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0; border-right: 1px solid #000;">
              ${creditValue}
            </td>
          </tr>
          `;
          } else {
            // Original logic when hideGroupTotal is false
            return `
          <tr>
            <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'
              }; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0; ${isGroupRow ? 'margin-bottom: 2px;' : ''
              } border-left: 1px solid #000;">
              ${'&nbsp;'.repeat((row.level || 0) * 8) + row.name}
            </td>
            <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'
              }; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0;">
              ${!isGroupRow && isDebit ? formatAmountWithColor(row?.balance || 0) : !isGroupRow && isCredit ? '--' : ''}
            </td>
            <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'
              }; font-weight: ${fontWeight}; font-style: italic; line-height: 1.0;">
              ${isGroupRow && isDebit ? formatAmountWithColor(row?.balance || 0) : isGroupRow && isCredit ? '--' : ''}
            </td>
            <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'
              }; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0;">
              ${!isGroupRow && isCredit ? formatAmountWithColor(row?.balance || 0) : !isGroupRow && isDebit ? '--' : ''}
            </td>
            <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'
              }; font-weight: ${fontWeight}; font-style: italic; line-height: 1.0; border-right: 1px solid #000;">
              ${isGroupRow && isCredit ? formatAmountWithColor(row?.balance || 0) : isGroupRow && isDebit ? '--' : ''}
            </td>
          </tr>
          `;
          }
        })
        .join('')}
      
      ${params?.openingBalanceDiff?.debit !== 0
        ? `
        <tr>
          <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: normal; font-style: italic; color: #FF0000; line-height: 1.0; border-left: 1px solid #000;">
            ${params?.openingBalanceDiff?.name}
      </td>
          ${hideGroupTotal
          ? `
          <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; color: #FF0000; line-height: 1.0;">
            ${formatAmountWithColor(params?.openingBalanceDiff?.debit || 0)}
          </td>
          <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; line-height: 1.0; border-right: 1px solid #000;">
            --
          </td>
          `
          : `
          <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; color: #FF0000; line-height: 1.0;">
            ${formatAmountWithColor(params?.openingBalanceDiff?.debit || 0)}
          </td>
          <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; color: #FF0000; line-height: 1.0;">
            ${formatAmountWithColor(params?.openingBalanceDiff?.debit || 0)}
          </td>
          <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; line-height: 1.0;">
            --
          </td>
          <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0; border-right: 1px solid #000;">
            --
          </td>
          `
        }
        </tr>
      `
          : ''
      }
      
      ${params?.openingBalanceDiff?.credit !== 0
        ? `
        <tr>
          <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: normal; font-style: italic; color: #FF0000; line-height: 1.0; border-left: 1px solid #000;">
            ${params?.openingBalanceDiff?.name}
          </td>
          ${hideGroupTotal
          ? `
          <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; line-height: 1.0;">
            --
          </td>
          <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; color: #FF0000; line-height: 1.0; border-right: 1px solid #000;">
            ${formatAmountWithColor(params?.openingBalanceDiff?.credit || 0)}
          </td>
          `
          : `
          <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; line-height: 1.0;">
            --
          </td>
          <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">
            --
          </td>
          <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-style: italic; color: #FF0000; line-height: 1.0;">
            ${formatAmountWithColor(params?.openingBalanceDiff?.credit || 0)}
          </td>
          <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; color: #FF0000; line-height: 1.0; border-right: 1px solid #000;">
            ${formatAmountWithColor(params?.openingBalanceDiff?.credit || 0)}
          </td>
          `
        }
        </tr>
      `
        : ''
      }

      <!-- Total Row -->
      <tr>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">
          Total
        </td>
        ${hideGroupTotal
        ? `
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">
          ${formatAmountWithColor(totalDebit || 0)}
        </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0; border-right: 1px solid #000;">
          ${formatAmountWithColor(totalCredit || 0)}
        </td>
        `
        : `
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; line-height: 1.0;">
          ${formatAmountWithColor(totalDebit || 0)}
        </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; line-height: 1.0;">
          ${formatAmountWithColor(totalDebit || 0)}
        </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; line-height: 1.0;">
          ${formatAmountWithColor(totalCredit || 0)}
        </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; line-height: 1.0;">
          ${formatAmountWithColor(totalCredit || 0)}
        </td>
        `
      }
    </tr>
    </tbody>
    </table>
</div>
    `;
  } else if (type === 'Item') {
    const flatRows = params?.rows || [];

    // Calculate totals for Items recursively
    const calculateItemTotals = (rows) => {
      return rows.reduce(
        (acc, row) => {
          if (row.category === 'Item') {
            acc.totalQty += row.qty || 0;
            acc.totalPrice += row.price || 0;
          } else if (row.children && row.children.length > 0) {
            // Recursively process children for categories
            const childTotals = calculateItemTotals(row.children);
            acc.totalQty += childTotals.totalQty;
            acc.totalPrice += childTotals.totalPrice;
          }
          return acc;
        },
        { totalQty: 0, totalPrice: 0 }
      );
    };

    const itemTotals = calculateItemTotals(params?.rows || []);

    const generateItemRows = () => {
      let rows = '';

      flatRows.forEach((row) => {
        const isGroupRow = row.category === 'Category';
        const fontWeight = isGroupRow ? 'bold' : 'normal';
        const fontStyle = isGroupRow ? 'normal' : 'italic';
        const textColor = isGroupRow ? '#911B7C' : 'inherit';

        const isGoodsType = row.type === 'GOODS';
        const unitValue = !isGroupRow && isGoodsType ? row.unit || '' : !isGroupRow && !isGoodsType ? '--' : '';
        const qtyValue = !isGroupRow && isGoodsType ? row.qty || 0 : !isGroupRow && !isGoodsType ? '--' : '';
        const ledgerValue = !isGroupRow && isGoodsType ? formatAmountWithColor(row.price || 0) : !isGroupRow && !isGoodsType ? '--' : '';
        const groupValue =
          isGroupRow && !hideGroupTotal && isGoodsType
            ? formatAmountWithColor(row.price || 0)
            : isGroupRow && !hideGroupTotal && !isGoodsType
              ? '--'
              : '';

        rows += `
          <tr>
            <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'
          }; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0; ${isGroupRow ? 'margin-bottom: 2px;' : ''
          }">
              ${'&nbsp;'.repeat((row.level || 0) * 8) + row.name}
            </td>
            <td style="padding: 2px; text-align: center; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'
          }; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0;">
              ${unitValue}
            </td>
            <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'
          }; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0;">
              ${qtyValue}
            </td>
            <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'
          }; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''
          }">
              ${ledgerValue}
            </td>
            ${!hideGroupTotal
            ? `<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'
            }; font-weight: ${fontWeight}; font-style: italic; line-height: 1.0;">
              ${groupValue}
            </td>`
            : ''
          }
          </tr>
        `;
      });

      return rows;
    };

    printableTable += `
<div style="width: 100%; font-family: Calibri, Arial; margin: 0; padding: 0;">
  <table style="width: 100%; border-collapse: collapse; font-size: 9pt; line-height: 1.1;">
    <colgroup>
      <col style="width: ${hideGroupTotal ? '40%' : '30%'};">
      <col style="width: ${hideGroupTotal ? '30%' : '20%'};">
      <col style="width: ${hideGroupTotal ? '30%' : '20%'};">
      <col style="width: ${hideGroupTotal ? '0%' : '15%'};">
      ${!hideGroupTotal ? '<col style="width: 15%;">' : ''}
    </colgroup>
    <thead>
      <tr>
        <th style="padding: 4px; text-align: left; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; background-color: #911B7C; color: white;">
          Items
        </th>
        <th style="padding: 4px; text-align: center; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; background-color: #911B7C; color: white;">
          Unit
        </th>
        <th style="padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; background-color: #911B7C; color: white;">
          Qty
        </th>
        <th ${hideGroupTotal
        ? 'style="padding: 4px; text-align: center; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; background-color: #911B7C; color: white;"'
        : 'colspan="2" style="padding: 4px; text-align: center; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; background-color: #911B7C; color: white;"'
      }>
          Total value
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td colspan="${hideGroupTotal ? '4' : '5'
      }" style="width: 100%; padding: 0; vertical-align: top; border-left: 1px solid #000; border-right: 1px solid #000;">
          <table style="width: 100%; border-collapse: collapse;">
            <colgroup>
              <col style="width: ${hideGroupTotal ? '40%' : '30%'};">
              <col style="width: ${hideGroupTotal ? '30%' : '20%'};">
              <col style="width: ${hideGroupTotal ? '30%' : '20%'};">
              <col style="width: ${hideGroupTotal ? '0%' : '15%'};">
              ${!hideGroupTotal ? '<col style="width: 15%;">' : ''}
            </colgroup>
            <tbody>
              ${generateItemRows()}
            </tbody>
          </table>
        </td>
      </tr>
        
      <!-- Total Row -->
      <tr>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">
          Total
        </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: center; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">
        </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">
        </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; line-height: 1.0; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''
      }">
          ${formatAmountWithColor(itemTotals.totalPrice || 0)}
        </td>
        ${!hideGroupTotal
        ? `<td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; line-height: 1.0;">
          ${formatAmountWithColor(itemTotals.totalPrice || 0)}
        </td>`
        : ''
      }
      </tr>
    </tbody>
    </table>
</div>
    `;
  } else {
    // For single tables like Receivables, Payables
    const flatRows = recursiveRowFn(params.rows || []);
    const { total } = await getTotal(params.rows);

    const generateSingleTableRows = () => {
      let rows = '';

      flatRows.forEach((row) => {
        if (!(hideZeroBalLedger && row?.balance === 0 && row?.category === 'ledger')) {
          const isGroupRow = row.category === 'group' || row?.category === 'Category';
          const fontWeight = isGroupRow ? 'bold' : 'normal';
          const fontStyle = isGroupRow ? 'normal' : 'italic';
          const textColor = isGroupRow ? '#911B7C' : 'inherit';

          rows += `
            <tr>
              <td style="padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'
            }; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0; ${isGroupRow ? 'margin-bottom: 2px;' : ''
            }">
                ${'&nbsp;'.repeat((row.level || 0) * 8) + row.name}
              </td>
              <td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'
            }; font-weight: ${fontWeight}; font-style: ${fontStyle}; color: ${textColor}; line-height: 1.0; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''
            }">
                ${!isGroupRow ? formatAmountWithColor(row?.balance || 0) : ''}
              </td>
              ${!hideGroupTotal
              ? `<td style="padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: ${isGroupRow ? '9pt' : '8pt'
              }; font-weight: ${fontWeight}; font-style: italic; line-height: 1.0;">
                ${isGroupRow ? formatAmountWithColor(row?.balance || 0) : ''}
              </td>`
              : ''
            }
            </tr>
          `;
        }
      });

      return rows;
    };

    printableTable += `
<div style="width: 100%; font-family: Calibri, Arial; margin: 0; padding: 0;">
  <table style="width: 100%; border-collapse: collapse; font-size: 9pt; line-height: 1.1;">
    <thead>
     <tr>
        <th style="width: ${hideGroupTotal ? '66.67%' : '50%'
      }; padding: 4px; text-align: left; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; background-color: #911B7C; color: white;">
          ${type}
        </th>
        <th style="width: ${hideGroupTotal ? '33.33%' : '25%'
      }; padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''
      } background-color: #911B7C; color: white;">
          Amount
        </th>
        ${!hideGroupTotal
        ? `<th style="width: 25%; padding: 4px; text-align: right; font-family: Calibri, Arial; font-size: 10pt; font-weight: bold; border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; background-color: #911B7C; color: white;">
          Group Total
        </th>`
        : ''
      }
    </tr>
    </thead>
    <tbody>
      <tr>
        <td colspan="${hideGroupTotal ? '2' : '3'
      }" style="width: 100%; padding: 0; vertical-align: top; border-left: 1px solid #000; border-right: 1px solid #000;">
          <table style="width: 100%; border-collapse: collapse;">
            <colgroup>
              <col style="width: ${hideGroupTotal ? '66.67%' : '50%'};">
              <col style="width: ${hideGroupTotal ? '33.33%' : '25%'};">
              ${!hideGroupTotal ? '<col style="width: 25%;">' : ''}
            </colgroup>
            <tbody>
              ${generateSingleTableRows()}
            </tbody>
          </table>
        </td>
      </tr>

      <!-- Total Row -->
      <tr>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-left: 1px solid #000; padding: 2px; text-align: left; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; line-height: 1.0;">
        Total
      </td>
        <td style="border-top: 1px solid #000; border-bottom: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; line-height: 1.0; ${hideGroupTotal ? 'border-right: 1px solid #000;' : ''
      }">
          ${formatAmountWithColor(total || 0)}
        </td>
        ${!hideGroupTotal
        ? `<td style="border-top: 1px solid #000; border-bottom: 1px solid #000; border-right: 1px solid #000; padding: 2px; text-align: right; font-family: Calibri, Arial; font-size: 8pt; font-weight: bold; font-style: italic; line-height: 1.0;">
          ${formatAmountWithColor(total || 0)}
        </td>`
        : ''
      }
    </tr>
    </tbody>
    </table>
</div>
    `;
  }

  printJS({
    printable: printableTable,
    type: 'raw-html',
    header: `<h3 style="text-align: center;">${tableTitle}</h3>`,
    style: `
      @page {
        size: A4 portrait;
        margin: 0.1in;
      }
      body {
        font-family: Calibri, Arial;
        font-size: 9pt;
        line-height: 1.1;
      }
      table {
        width: 100%;
        border-collapse: collapse;
      }
      th, td {
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
      th[style*="background-color"] {
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
      th[style*="#911B7C"] {
        background-color: #911B7C !important;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
      th[style*="#C8087F"] {
        background-color: #C8087F !important;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
      * {
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
      .header-purple {
        background-color: #911B7C !important;
        color: white !important;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
      .header-pink {
        background-color: #C8087F !important;
        color: white !important;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
    `,
    scanStyles: true,
    targetStyles: ['*'],
    ignoreElements: [],
    documentTitle: tableTitle,
    showModal: true,
    modalMessage: 'Preparing document for printing...',
    onPrintDialogClose: () => { },
    onError: (e) => {
      console.error('Print error:', e);
    },
  });
}
